import { Inline } from '@syl-editor/core-utilities';

class DIYLink extends Inline<any> {
  public name = 'diyLink'; // 元素名称

  public tagName = () => 'a'; // 元素标签

  public getText = true;

  public textMatcher = [ // 匹配正则 快捷
    {
      matcher: /\[(.*)\]\((.*)\)\s/,
      handler(match: string[]) {
        return {
          text: match[1],
          href: match[2],
        };
      },
    },

  ];

  public attrs = {
    href: {
      default: '',
    },
    text: {
      default: '',
    },

  };

  public parseDOM = [{
    tag: 'a[href]',
    getAttrs(dom: HTMLAnchorElement): any {
      if (!dom.textContent && !dom.getAttribute('text')) {
        return false;
      }
      // solve the problem of copying itself
      const text = dom.textContent || dom.getAttribute('text') || '';
      return {
        href: dom.getAttribute('href'),
        text,
      };
    },
  },
  ]; // 匹配的DOM节点

  // 可选，扩展渲染，优先级比tagName高
  public toDOM = (node: any) => {
    // 第一位渲染DOM标签名，此处为'code'； 第二位指DOM上面的属性，此处指class="code"
    // 结果为 <a class="my_link_a">xxx</a>
    const { attrs } = node;
    return ['a', { class: 'my_link_a', target: '_blank', ...attrs }, 0];
  };
}

export default DIYLink;
